export function EcoAssistParrot({ className = '' }) {
  return (
    <svg
      aria-hidden="true"
      className={`eco-assist-parrot ${className}`}
      viewBox="0 0 96 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M50 79c9 9 12 19 10 30-8-7-14-15-18-25" fill="#C9A961" />
      <path d="M40 80c-1 12-5 21-13 29 0-12 2-22 7-30" fill="#E4835E" />
      <ellipse cx="43" cy="65" rx="25" ry="29" fill="#1E4A3C" />
      <path className="eco-assist-parrot__wing" d="M22 58c7 2 15 8 22 20-10 2-19-2-24-10-3-5-2-8 2-10Z" fill="#2F7560" />
      <path d="M62 47c7 5 11 12 12 20-5-3-9-8-13-14" fill="#122E26" opacity=".32" />
      <g className="eco-assist-parrot__head">
        <circle cx="45" cy="35" r="24" fill="#2F7560" />
        <path d="M25 31c4-16 20-25 35-18-10 1-18 6-24 16" fill="#3E8D73" />
        <path d="M61 31c14-3 23 1 28 8-7 4-15 5-25 2" fill="#C9A961" />
        <path d="M88 39c-5 8-13 12-24 10l1-9c9 2 17 1 23-1Z" fill="#E4835E" />
        <ellipse cx="55" cy="30" rx="8" ry="9" fill="#F7F0E4" />
        <circle className="eco-assist-parrot__eye" cx="57" cy="29" r="3.2" fill="#122E26" />
        <path d="M30 44c7 5 16 7 27 5-4 8-11 12-20 10" fill="#C9A961" opacity=".9" />
      </g>
      <path d="M24 86c9 3 20 4 34 1" stroke="#F7F0E4" strokeWidth="2" strokeLinecap="round" opacity=".45" />
    </svg>
  );
}
